import React, { useMemo } from 'react'

import { getElement } from 'components/Editor/EditorContext/selectors/block'
import EditorElementComponent from 'components/Editor/EditorElements/EditorElementComponent'
import { EMPTY_OBJECT } from 'constants/commonConstans'
import { mergeNodeStyle } from 'services/Store/Project/selectors'

import type { INodeV2Props } from '../../cource/layout/Node/types'
import { isRoot } from '../guards'
import NodeV2Styled from '../styled/NodeV2Styled'

const SkeletonNodeV2: React.FC<INodeV2Props> = ({
  children,
  node,
  block,
  mode,
  parent,
  styles,
  isPreview,
  isSlot,
}) => {
  const element = node.elementId ? getElement(block, node.elementId) : null
  const style = useMemo(
    () => mergeNodeStyle(node.style, mode.deviceMode, element?.type),
    [element?.type, mode.deviceMode, node.style],
  )
  const parentStyle = useMemo(
    () => mergeNodeStyle(parent?.style || EMPTY_OBJECT, mode.deviceMode),
    [mode.deviceMode, parent?.style],
  )

  return (
    <NodeV2Styled
      $element={element}
      $isRoot={isRoot(block, node)}
      $isSlot={isSlot}
      $node={node}
      $parent={parent}
      $parentStyle={parentStyle}
      $style={style}
      style={{ ...styles, ...(isPreview && { top: 0, left: 0, position: 'relative' }) }}
    >
      {element ? (
        <EditorElementComponent block={block} element={element} mode={mode} isV2 />
      ) : (
        children
      )}
    </NodeV2Styled>
  )
}

export default React.memo(SkeletonNodeV2)
